"use strict";

exports.__esModule = true;
var _timeSeriesAxis = require("./timeSeriesAxis");
Object.keys(_timeSeriesAxis).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _timeSeriesAxis[key]) return;
  exports[key] = _timeSeriesAxis[key];
});